import React from 'react';
import { useEffect, useMemo } from "react";
import { RaitingSortContainer, SortName, SortPrefix, SortType } from "./styles";
import { Dropdown, DropdownListItem, Skeleton } from "@brg/ui";
import { ApprovedIcon, ArrowIcon } from "./ArrowIcon";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentLongread } from "../../../../../reducers/longreadBlocks";
import { updateSortRaiting } from "../../../../../actions/sortRaitingAction";
import { getSorting } from "../../../../../reducers/sortRaiting";
import useLocalization from "../../../../../hooks/useLocalization";
import { Lang } from "@brg/api";
import { useTheme } from "styled-components";
var DEFAULT_SORT_TYPE = 'like';
var TRANSLATED_DEFAULT_SORT = { like: { name: [{ lang: 'ru', name: 'официальный рейтинг' }, { lang: 'en', name: 'official rating' }] } };
export var RaitingSort = function (_a) {
    var _b;
    var longreadId = _a.longreadId;
    var currentStore = useSelector(function (store) { return getCurrentLongread(store, longreadId); });
    var currentSorting = (_b = useSelector(function (store) { return getSorting(store); })) === null || _b === void 0 ? void 0 : _b.sorting;
    var dispatch = useDispatch();
    var theme = useTheme();
    var _c = useLocalization(), t = _c.t, language = _c.language;
    var hasLikeRaiting = useMemo(function () { var _a; return ((_a = currentStore.blocks) === null || _a === void 0 ? void 0 : _a.find(function (p) { var _a; return (_a = p === null || p === void 0 ? void 0 : p.ratings) === null || _a === void 0 ? void 0 : _a[DEFAULT_SORT_TYPE]; })); }, [currentStore]);
    var isLoading = useMemo(function () { var _a; return ((_a = currentStore.blocks) === null || _a === void 0 ? void 0 : _a.some(function (p) { return (p === null || p === void 0 ? void 0 : p.postId) === 'updating' || (p === null || p === void 0 ? void 0 : p.postId) === 'loading'; })); }, [currentStore]);
    var sortTypes = useMemo(function () {
        var _a;
        var blocks = (_a = currentStore.blocks) === null || _a === void 0 ? void 0 : _a.filter(function (i) { var _a; return !!(i === null || i === void 0 ? void 0 : i.useRating) && !!((_a = Object.keys(i === null || i === void 0 ? void 0 : i.ratings)) === null || _a === void 0 ? void 0 : _a.length); });
        var unicRaitings = [];
        blocks === null || blocks === void 0 ? void 0 : blocks.forEach(function (_a) {
            var _b;
            var ratings = _a.ratings;
            var f = (_b = Object.keys(ratings)) === null || _b === void 0 ? void 0 : _b[0];
            if (!(unicRaitings === null || unicRaitings === void 0 ? void 0 : unicRaitings.find(function (i) { var _a; return ((_a = Object.keys(i)) === null || _a === void 0 ? void 0 : _a[0]) === f; }))) {
                unicRaitings.push(ratings);
            }
        });
        if (!hasLikeRaiting) {
            unicRaitings.push(TRANSLATED_DEFAULT_SORT);
        }
        return unicRaitings;
    }, [currentStore, hasLikeRaiting]);
    console.log('tst store', sortTypes);
    var sorting = useMemo(function () {
        var _a, _b;
        return ((_b = (_a = sortTypes === null || sortTypes === void 0 ? void 0 : sortTypes.find(function (i) { return i === null || i === void 0 ? void 0 : i[currentSorting]; })) === null || _a === void 0 ? void 0 : _a[currentSorting]) === null || _b === void 0 ? void 0 : _b.name) || (TRANSLATED_DEFAULT_SORT === null || TRANSLATED_DEFAULT_SORT === void 0 ? void 0 : TRANSLATED_DEFAULT_SORT.like);
    }, [currentSorting, t]);
    var prefix = useMemo(function () { return (t('sorting.raiting.prefix')); }, [t]);
    var updateSorting = function (s) {
        dispatch(updateSortRaiting(s));
    };
    var sortDropdown = useMemo(function () {
        var _a;
        if (isLoading) {
            return null;
        }
        return (React.createElement(Dropdown, { orientation: 'right', width: '300px', hideArrow: true, target: React.createElement(ArrowIcon, { text: ((_a = Lang(sorting, language)) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || 'Название отсутствует' }) }, !!(sortTypes === null || sortTypes === void 0 ? void 0 : sortTypes.length) && (sortTypes === null || sortTypes === void 0 ? void 0 : sortTypes.map(function (i) {
            var _a;
            var computeData = ((_a = Object === null || Object === void 0 ? void 0 : Object.entries(i)) === null || _a === void 0 ? void 0 : _a[0]) || [];
            var key = computeData[0], name = computeData[1].name;
            var tLangName = Lang(name, language);
            return (React.createElement(DropdownListItem, { active: currentSorting === key, key: key, onClick: function () { return updateSorting(key); } },
                React.createElement("span", null, (tLangName === null || tLangName === void 0 ? void 0 : tLangName.toLowerCase()) || 'Название отсутствует'),
                React.createElement(ApprovedIcon, { fill: theme.icon.active, display: key === currentSorting })));
        }))));
    }, [updateSorting, sorting, sortTypes, isLoading]);
    useEffect(function () {
        if (!currentSorting) {
            updateSorting(DEFAULT_SORT_TYPE);
        }
    }, [currentSorting]);
    return (React.createElement(RaitingSortContainer, null,
        React.createElement(SortName, null, isLoading ? (React.createElement(Skeleton, { width: '300px' })) : (React.createElement(React.Fragment, null,
            React.createElement(SortPrefix, null, prefix),
            React.createElement(SortType, null, sortDropdown))))));
};
//# sourceMappingURL=RaitingSort.js.mapimport React from 'react';
import { useEffect, useMemo } from "react";
import { RaitingSortContainer, SortName, SortPrefix, SortType } from "./styles";
import { Dropdown, DropdownListItem, Skeleton } from "@brg/ui";
import { ApprovedIcon, ArrowIcon } from "./ArrowIcon";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentLongread } from "../../../../../reducers/longreadBlocks";
import { updateSortRaiting } from "../../../../../actions/sortRaitingAction";
import { getSorting } from "../../../../../reducers/sortRaiting";
import useLocalization from "../../../../../hooks/useLocalization";
import { Lang } from "@brg/api";
import { useTheme } from "styled-components";
var DEFAULT_SORT_TYPE = 'like';
var TRANSLATED_DEFAULT_SORT = { like: { name: [{ lang: 'ru', name: 'официальный рейтинг' }, { lang: 'en', name: 'official rating' }] } };
export var RaitingSort = function (_a) {
    var _b;
    var longreadId = _a.longreadId;
    var currentStore = useSelector(function (store) { return getCurrentLongread(store, longreadId); });
    var currentSorting = (_b = useSelector(function (store) { return getSorting(store); })) === null || _b === void 0 ? void 0 : _b.sorting;
    var dispatch = useDispatch();
    var theme = useTheme();
    var _c = useLocalization(), t = _c.t, language = _c.language;
    var hasLikeRaiting = useMemo(function () { var _a; return ((_a = currentStore.blocks) === null || _a === void 0 ? void 0 : _a.find(function (p) { var _a; return (_a = p === null || p === void 0 ? void 0 : p.ratings) === null || _a === void 0 ? void 0 : _a[DEFAULT_SORT_TYPE]; })); }, [currentStore]);
    var isLoading = useMemo(function () { var _a; return ((_a = currentStore.blocks) === null || _a === void 0 ? void 0 : _a.some(function (p) { return (p === null || p === void 0 ? void 0 : p.postId) === 'updating' || (p === null || p === void 0 ? void 0 : p.postId) === 'loading'; })); }, [currentStore]);
    var sortTypes = useMemo(function () {
        var _a;
        var blocks = (_a = currentStore.blocks) === null || _a === void 0 ? void 0 : _a.filter(function (i) { var _a; return !!(i === null || i === void 0 ? void 0 : i.useRating) && !!((_a = Object.keys(i === null || i === void 0 ? void 0 : i.ratings)) === null || _a === void 0 ? void 0 : _a.length); });
        var unicRaitings = [];
        blocks === null || blocks === void 0 ? void 0 : blocks.forEach(function (_a) {
            var _b;
            var ratings = _a.ratings;
            var f = (_b = Object.keys(ratings)) === null || _b === void 0 ? void 0 : _b[0];
            if (!(unicRaitings === null || unicRaitings === void 0 ? void 0 : unicRaitings.find(function (i) { var _a; return ((_a = Object.keys(i)) === null || _a === void 0 ? void 0 : _a[0]) === f; }))) {
                unicRaitings.push(ratings);
            }
        });
        if (!hasLikeRaiting) {
            unicRaitings.push(TRANSLATED_DEFAULT_SORT);
        }
        return unicRaitings;
    }, [currentStore, hasLikeRaiting]);
    console.log('tst store', sortTypes);
    var sorting = useMemo(function () {
        var _a, _b;
        return ((_b = (_a = sortTypes === null || sortTypes === void 0 ? void 0 : sortTypes.find(function (i) { return i === null || i === void 0 ? void 0 : i[currentSorting]; })) === null || _a === void 0 ? void 0 : _a[currentSorting]) === null || _b === void 0 ? void 0 : _b.name) || (TRANSLATED_DEFAULT_SORT === null || TRANSLATED_DEFAULT_SORT === void 0 ? void 0 : TRANSLATED_DEFAULT_SORT.like);
    }, [currentSorting, t]);
    var prefix = useMemo(function () { return (t('sorting.raiting.prefix')); }, [t]);
    var updateSorting = function (s) {
        dispatch(updateSortRaiting(s));
    };
    var sortDropdown = useMemo(function () {
        var _a;
        if (isLoading) {
            return null;
        }
        return (React.createElement(Dropdown, { orientation: 'right', width: '300px', hideArrow: true, target: React.createElement(ArrowIcon, { text: ((_a = Lang(sorting, language)) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || 'Название отсутствует' }) }, !!(sortTypes === null || sortTypes === void 0 ? void 0 : sortTypes.length) && (sortTypes === null || sortTypes === void 0 ? void 0 : sortTypes.map(function (i) {
            var _a;
            var computeData = ((_a = Object === null || Object === void 0 ? void 0 : Object.entries(i)) === null || _a === void 0 ? void 0 : _a[0]) || [];
            var key = computeData[0], name = computeData[1].name;
            var tLangName = Lang(name, language);
            return (React.createElement(DropdownListItem, { active: currentSorting === key, key: key, onClick: function () { return updateSorting(key); } },
                React.createElement("span", null, (tLangName === null || tLangName === void 0 ? void 0 : tLangName.toLowerCase()) || 'Название отсутствует'),
                React.createElement(ApprovedIcon, { fill: theme.icon.active, display: key === currentSorting })));
        }))));
    }, [updateSorting, sorting, sortTypes, isLoading]);
    useEffect(function () {
        if (!currentSorting) {
            updateSorting(DEFAULT_SORT_TYPE);
        }
    }, [currentSorting]);
    return (React.createElement(RaitingSortContainer, null,
        React.createElement(SortName, null, isLoading ? (React.createElement(Skeleton, { width: '300px' })) : (React.createElement(React.Fragment, null,
            React.createElement(SortPrefix, null, prefix),
            React.createElement(SortType, null, sortDropdown))))));
};
//# sourceMappingURL=RaitingSort.js.map